import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core'
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { interval } from 'rxjs'

interface NotificationData {
  message: string
  duration?: number
  isSuccess: boolean
  parameters?: Record<string, string> | null
}

@UntilDestroy()
@Component({
  selector: 'app-notification',
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- relies on pre-v22 default
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NotificationComponent implements OnInit {
  progressBarValue = 100

  isSuccess: boolean

  parameters: Record<string, string> = {}

  constructor(
    private snackBarRef: MatSnackBarRef<NotificationComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationData,
  ) {}

  ngOnInit(): void {
    const { duration, isSuccess, parameters } = this.data
    const durationInMilliseconds = duration / 100

    this.isSuccess = isSuccess

    this.parameters = parameters != null ? parameters : {}

    if (duration && duration > 0) {
      interval(100)
        .pipe(untilDestroyed(this))
        .subscribe(time => {
          this.progressBarValue = 100 - (time * 100) / durationInMilliseconds
        })
    }
  }

  dismiss(): void {
    this.snackBarRef.dismiss()
  }
}
